import styled from 'styled-components'

const PaginationStyle = styled.div`
	--paginationItemSizes: var(--sp4x);
	--paginationItemMargin: var(--sp0-5x);

	margin-top: var(--distanceM3);

	.pagination__list {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.disable {
		pointer-events: none;
		opacity: 60%;
	}

	.dots {
		margin: 0 var(--paginationItemMargin);
	}

	.pagination-item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: var(--paginationItemSizes);
		height: var(--paginationItemSizes);
		margin: 0 var(--paginationItemMargin);
		cursor: pointer;

		&.active {
			pointer-events: none;
			background-color: var(--birodoGreen);
			color: var(--red100);
			text-decoration: underline;
		}
	}

	.next-btn,
	.prev-btn {
		display: flex;
		align-items: center;
		margin: 0 var(--paginationItemMargin);
		cursor: pointer;

		&.disable {
			display: none;
		}
	}

	.next-btn {
		margin-right: unset;
	}

	.prev-btn {
		transform: rotate(180deg);
		margin-left: unset;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--paginationItemSizes: var(--sp3x);
		--paginationItemMargin: var(--sp0-5x);
	}
`

export default PaginationStyle
